import React from 'react';
import DynamicCalendar from './DynamicCalendar';
import { Calendar, useCalendarQuery } from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';

interface Props {
	calendarId: string;
}

const DynamicCalendarWrapper: React.FC<Props> = ({ calendarId }) => {
	//LOADING CALENDAR INFO AND SETTINGS
	const { data, isLoading } = useCalendarQuery({ where: { id: calendarId } });

	if (isLoading) {
		return <Loading />;
	}

	if (!data?.calendar) {
		return <></>;
	}

	return <DynamicCalendar calendar={data.calendar as Calendar} />;
};

export default DynamicCalendarWrapper;
